<template>
	<div class="main">
		<h1>Lista de etiquetas</h1>
		<br />

		<v-card class="rounded-lg tag-card">
			<div class="before-table">
				<h1>Etiquetas</h1>
				<br />

				<div class="before-table-row">
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Buscar por #Pedido"
						@change="fetchTags"
					></v-text-field>
				</div>
			</div>

			<v-data-table
				:headers="headers"
				:items="tags"
				class="tag-list-table"
				:search="search"
				:items-per-page="20"
				:options.sync="options"
				:loading="loading"
				:footer-props="{
					itemsPerPageOptions: [5, 10, 20],
					itemsPerPageText: 'Etiquetas por página',
					pageText: `${
						1 + options.itemsPerPage * (options.page - 1)
					}-${
						options.itemsPerPage * options.page > tags.length
							? tags.length
							: options.itemsPerPage * options.page
					} de ${tags.length}`,
					showFirstLastPage: true,
				}"
				:header-props="{
					sortByText: 'Ordenar por',
				}"
			>
				<template #no-data>No hay etiquetas</template>

				<template #item.delete="{item}">
					<v-btn
						class="mx-1 rounded-lg"
						elevation="0"
						color="error"
						@click="deleteTag(item.tag)"
						>Borrar etiqueta</v-btn
					>
				</template>
			</v-data-table>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		name: "TagList",
		data: () => ({
			tags: [],
			search: "",
			options: {
				itemsPerPage: 20,
			},

			loading: false,

			headers: [
				{
					align: "center",
					text: "Etiqueta",
					value: "tag",
				},
				{
					align: "center",
					text: "Borrar",
					value: "delete",
				},
			],
		}),
		mounted() {
			this.fetchTags();
		},
		methods: {
			async fetchTags() {
				try {
					this.$emit("loading", true);
					this.loading = true;
					const response = await axios.get("/races/tags");
					this.tags = response.data.map((el) => ({ tag: el }));
				} catch (error) {
					if (error.response && error.response.status === 401) {
						this.$router.push({ name: "AdminLogin" });
					} else {
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				} finally {
					this.$emit("loading", false);
					this.loading = false;
				}
			},

			async deleteTag(tag) {
				try {
					await axios.delete("/races/tags", {
						data: {
							tag,
						},
					});

					this.$emit("snackbar-event", {
						color: "success",
						text: "Se ha borrado la etiqueta",
					});
				} catch (error) {
					this.$emit("snackbar-event", {
						color: "error",
						text: "No se ha podido borrar la etiqueta",
					});
				} finally {
					this.fetchTags();
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.main {
		padding: 2em;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.tag-card {
		max-width: 600px;
		.before-table {
			padding: 2em;

			.before-table-row {
				display: flex;
				flex-wrap: wrap;
			}
		}
	}
	.tag-list {
		.v-expansion-panel-header {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;

			p {
				margin: 0 0 0 1em;
			}
		}

		.v-expansion-panel-content {
			padding: 2em 0;
			background-color: #f0f0f0;
		}
	}
</style>

<style lang="scss">
	.tag-list-table {
		&.v-data-table table tbody td {
			padding: 1em !important;
		}
	}
</style>
